var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-editor',{attrs:{"permission":"blog","fields":_vm.fields,"publication":true,"updatePossible":true,"endpoint":"blog","previewModule":"blog","module":"blog"},on:{"update":_vm.updateState}})
}
var staticRenderFns = []

export { render, staticRenderFns }